import  { useEffect} from "react";
import { useDispatch, useSelector } from "react-redux";
import { usersListAction } from "../../redux/userList/userListAction";

import { persistor } from '../../redux/store';

import { useHistory } from "react-router-dom";
import { FaDatabase } from "react-icons/fa";



const NavbarD = ({socket, id}) => {
  
  const purga = () => {
   
   if (window.confirm('¿Are you shure to delete Db?')) {
     persistor.purge();
     window.location.reload() 
    }
     
  }

  const history = useHistory();
  const dispatch = useDispatch();
  const userList = useSelector(state =>state.userList.users  || []);

  useEffect(() => {
  if (id === 'chat') {
    id = 'My Chat';
  }

  dispatch(usersListAction([id]))
  }, [id])
  
  


  const handleChange = (e) => {
    e.preventDefault()
    console.log('id: ' + id);
    console.log('select:' + e.target.value);
     history.replace(e.target.value);
     close();
     
  } 


  const close = () => {
        socket.emit('close', id);
  }



  
 

useEffect(() => {
  const interval = setInterval(() => {
   //refresh();
  }, 10000);

  return () => clearInterval(interval); // solo se limpia al desmontar
}, []);
  
    
  return (
 <nav className="navbar navbar-expand navbar-dark bg-dark">
  <div className="container-fluid">
    <ul className="navbar-nav d-flex justify-content-between w-100 mx-2">
      
      <li className="nav-item me-2">
        <label className="form-label text-light">Select Chat:</label>
        <select className="form-select" style={{ maxWidth: '100px' }} onChange={handleChange} 
          
        >
          
          {userList.filter(v => v !== localStorage.getItem('userId'))
               .map((v, i) => (
              <option value={v} key={i}>{v}</option>
             ))}
        </select>
      </li>

      <li className="nav-item me-2">
        <div>
        <label className="form-label text-light" style={{width:'100%', height:'100%', backgroundColor:"transparent"}}></label>
        </div>
        <button className="btn btn-danger" onClick={purga}>Delete Db <FaDatabase color="green"/></button>
      </li>



    </ul>
  </div>
</nav>

  );
};

export default NavbarD;
